import { useCallback, useMemo } from "react";
import { useClasses } from "@api/class.api";
import { HistoryDetailsItem } from "@common/types/auditLog";
import {
    buildHistoryCatalogItemTable,
    HistoryCatalogItemTable,
} from "../utils/historyCatalogItemDetailsRows";

interface UseHistoryCatalogItemTableParams {
    logs: HistoryDetailsItem[];
    selectedFields: string[];
    isEnabled: boolean;
}

export function useHistoryCatalogItemTable({
    logs,
    selectedFields,
    isEnabled,
}: UseHistoryCatalogItemTableParams): HistoryCatalogItemTable {
    const { classesMap } = useClasses();
    const resolveClassLabel = useCallback(
        (classId: string) => classesMap.get(classId)?.label,
        [classesMap],
    );

    return useMemo(
        () =>
            buildHistoryCatalogItemTable({
                logs: isEnabled ? logs : [],
                selectedFields,
                resolveClassLabel,
            }),
        [isEnabled, logs, selectedFields, resolveClassLabel],
    );
}
